<template>
    <div class="user_con_main">
        <div class="order" v-if="work_list.length==0">
            <img src="../../assets/images/no.png" alt="">
            <p class="fontC">暂无订单~</p>
        </div>
        <div class="user_real_list" v-else>
            <div class="user_real_li" v-for="(item, index) in work_list" :key="index">
                <div class="user_real_top">
                    <div class="flex_ali">
                        <img :src="item.cover" class="user_realava" />
                        <div>
                            <p class="user_real_tit">{{ item.voicetext.substring(0, 12) }}</p>
                            <p class="user_real_desp">主播：{{ item.speakername }}</p>
                        </div>
                    </div>
                    <div class="user_real_r">
                        <p class="user_real_state1" :style="{
                color: formatClass(item.processstatus, item.crgstatus),
              }">
                            {{ formatState(item.processstatus, item.crgstatus) }}
                        </p>
                        <p>合计：&nbsp&nbsp￥{{ item.orderamount }}</p>
                    </div>
                </div>
                <div class="user_real_fun">
                    <div class="user_real_prompt">
                        <p>老师工作时间：9:00 — 18:00</p>
                        <p>如遇节假日和周末，顺延至下个工作日</p>
                    </div>
                    <div class="flex_ali">
                        <div class="user_real_btn user_real_btn2" @click="removeRealWork(item.wkid)">
                            取消订单
                        </div>
                        <div class="user_real_btn user_real_btn1" @click="customerService">联系客服</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex_aro_h">
            <el-pagination background layout="prev, pager, next" :total="total" @current-change="changeWoeks">
            </el-pagination>
        </div>
        <RealCode v-if="show_code" @hide="show_code=false"/>
    </div>
</template>
<script>
import RealCode from "../../components/realcode.vue";
export default {
    components:{
        RealCode:RealCode
    },
    data() {
        return {
            page: 1, //分页页数
            work_list: [], //作品列表
            total: 0, //数据总数
            show_code:false,//客服二维码显示状态
        };
    },
    mounted() {
        this.getWorks();
    },
    methods: {
        // 联系客服
        customerService() {
            this.show_code = !this.show_code
        },
        // 删除真人作品
        removeRealWork(realwkid) {
            let self = this;
            this.$confirm("确认删除该作品?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let json = {
                    wkid: realwkid,
                    status: "0",
                };
                let url =
                    self.$store.state.app_api +
                    self.$store.state.app_url.uptlivework;
                this.$request.postHttp(json, url, (decData) => {
                    if (decData.rc !== "0") {
                        self.$message.error("删除失败！");
                        return;
                    }
                    self.$message({
                        message: "删除成功！",
                        type: "success",
                    });
                    self.getWorks();
                });
            });
        },
        // 格式化状态
        formatState(process, crg) {
            if (crg == 0) {
                return "待支付";
            }
            if (crg == 1 && process < 2) {
                return "已接单";
            }
            if (process == 2 || process == 3 || process == 5) {
                return "配音中";
            }
            if (process == 4 || process == 6) {
                return "已完成";
            }
            return "";
        },
        // 格式化状态样式
        formatClass(process, crg) {
            if (crg == 0) {
                return "#DE1C31";
            }
            if (crg == 1 && process < 2) {
                return "#333333";
            }
            if (process == 2 || process == 3 || process == 5) {
                return "#FE8A06";
            }
            if (process == 4 || process == 6) {
                return "#999999";
            }
            return "";
        },
        // 获取作品列表
        getWorks() {
            let self = this;
            let json = {
                page: this.page,
                rows: 10,
            };
            let url =
                self.$store.state.app_api +
                self.$store.state.app_url.qryliveworklist;
            this.$request.postHttp(json, url, (decData) => {
                console.log(decData);
                self.work_list = decData.model.list;
                self.total = decData.model.total;
                self.$globalFun.goTop();
            });
        },
        // 分页点击事件
        changeWoeks(e) {
            this.page = e;
            this.getWorks();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/view/user/user_real.vue